import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { Angulartics2Module } from 'angulartics2';
import { NgSelectModule } from '@ng-select/ng-select';

import { CheckboxGroupModule } from '@tablesready/checkbox-group';
import {
  FormValidationModule,
  UtilsModule,
  SearchBarModule,
  InfoModalModule,
  SortableColumnModule,
  TabsModule,
} from '@tablesready/common-ui';
import { ButtonGroupControlModule } from '@tablesready/button-group-control';
import { BadgeModule } from '@tablesready/frontend-badge';
import { AccountUsersComponent } from './users.component';
import { AccountUsersRoutingModule } from './users.routing.module';
import { InviteUserComponent } from './modals';
import {
  UsersListComponent,
  InvitesListComponent,
  InvitesFilterService,
} from './components';
import { UsersFilterService } from './components/users-list/users.filter.service';
import { UsersListService } from './components/users-list/users-list.service';
import { EditUserAccessService } from './services';
import { FrontendIconsModule } from '@tablesready/frontend-icons';
import { AuthModule } from '@tablesready/frontend-auth';
import { AlertsModule } from '@tablesready/frontend-alerts-bar';
import { FrontendDropdownModule } from '@tablesready/frontend-dropdown';
import { FrontendModalModule } from '@tablesready/frontend-modal';
import { FrontendPullRefreshModule } from '@tablesready/frontend-pull-refresh';

@NgModule({
  declarations: [
    AccountUsersComponent,
    InviteUserComponent,
    UsersListComponent,
    InvitesListComponent,
  ],
  imports: [
    FrontendIconsModule,
    CommonModule,
    AuthModule,
    AlertsModule,
    FormValidationModule,
    NgbModule,
    FormsModule,
    ReactiveFormsModule,
    Angulartics2Module,
    UtilsModule,
    AccountUsersRoutingModule,
    BadgeModule,
    SearchBarModule,
    ButtonGroupControlModule,
    InfoModalModule,
    SortableColumnModule,
    TabsModule,
    NgSelectModule,
    CheckboxGroupModule,
    FrontendDropdownModule,
    FrontendModalModule,
    FrontendPullRefreshModule,
  ],
  providers: [
    UsersListService,
    UsersFilterService,
    InvitesFilterService,
    EditUserAccessService,
  ],
})
export class AccountUsersModule {}
